export enum FinanceStatus {
  Active = 'Active',
  Expired = 'Expired',
  Pending = 'Pending',
  ExpiringSoon = 'ExpiringSoon',
  HighNet = 'HighNet',
  SoftPull = 'SoftPull'
}

export enum FinanceCardType {
  Active = 'Active',
  Default = 'Default',
  Expired = 'Expired'
}
